import {Sequence} from 'components/Sequence';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import Protein from 'molbio/proteins/Protein';

export function getInitialFolderIdForDuplicate(polymer: Protein | Sequence): string | null {
  const projectFolderId =
    polymer instanceof Protein ? polymer.projectFolderId() : polymer.get('projectFolderId');
  const folder = polymer.folder();
  if (projectFolderId != null) {
    return projectFolderId;
  } else if (folder != null && folder.source?.sourceType !== ModelTypeConstants.REGISTRY) {
    return folder.api_identifier;
  } else {
    return FolderDefaults.get(FolderDefaultsKey.INVENTORY) ?? null;
  }
}
